export { PizzaArea } from './PizzaArea';
export { BrandsImage } from './BrandsImage';
